import React from 'react';
import { Sparkline } from './Sparkline';
export function Header() {
  const sparklineData = [182, 183, 181, 184, 185, 183, 186, 187, 185, 188, 187, 189, 188, 187, 186, 188, 189, 187, 186, 185, 187, 188, 186, 187, 189, 188, 187, 186, 187, 187.42];
  return <header className="mb-12" data-id="element-11">
      <div className="flex items-center gap-2 mb-8" data-id="element-12">
        <span className="text-sm font-medium text-zinc-400" data-id="element-13">StockSage</span>
        <div className="w-1.5 h-1.5 rounded-full bg-yellow-400" data-id="element-14"></div>
      </div>

      <div className="flex items-start justify-between gap-8 flex-wrap" data-id="element-15">
        <div className="flex-1 min-w-[200px]" data-id="element-16">
          <h1 className="text-5xl font-bold text-zinc-50 mb-2" style={{
          fontFamily: "'Instrument Serif', serif"
        }} data-id="element-17">
            AAPL
          </h1>
          <p className="text-zinc-400 text-sm mb-6" data-id="element-18">Apple Inc.</p>

          <div className="flex items-baseline gap-3" data-id="element-19">
            <span className="text-3xl font-semibold text-zinc-50" data-id="element-20">$187.42</span>
            <span className="text-green-500 text-sm font-medium flex items-center gap-1" data-id="element-21">
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" className="translate-y-[-1px]" data-id="element-22">
                <path d="M6 2L6 10M6 2L3 5M6 2L9 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-23" />
              </svg>
              +$2.13 (+1.15%)
            </span>
          </div>
        </div>

        <div className="flex flex-col items-end" data-id="element-24">
          <span className="text-xs text-zinc-500 mb-2" data-id="element-25">Last 30 days</span>
          <Sparkline data={sparklineData} data-id="element-26" />
        </div>
      </div>
    </header>;
}